import { docReady } from '../helpers/docReady';
import '../../styles/templates/article.scss';
docReady(() => {
    console.log('Cardigang: Article JS Loaded');
});
